<div class="container out-box">
    <div class="typechange">
        <div class="type" routerLink="hotels" routerLinkActive="type-active">Hotels</div>
        <div class="type" routerLink="resorts" routerLinkActive="type-active">Resorts</div>
    </div>

    <router-outlet></router-outlet>
</div>